import React from "react"
import { createContext } from "use-context-selector"
import {useAppContextState} from "app/@hooks";

const Context = createContext({})

export function ParityMainHotelsProvider({children}) {
    const { state, replaceState, resetState, updateState } = useAppContextState({})

    return <Context.Provider value={{state, replaceState, updateState, resetState}}>
        {children}
    </Context.Provider>

}

export default Context